module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "p9000f1639970008001"
    }
  }), _c('h2', {
    staticClass: "chapter-title"
  }, [_vm._v("in the beginning…")]), _c('a', {
    attrs: {
      "id": "p9000f1639960008001"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f163g8001.png",
      "width": "90.38113%"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "p9000f1639970009001"
    }
  }), _c('div', {
    staticClass: "ahead"
  }, [_c('h3', {
    staticClass: "ahead-title"
  }, [_c('strong', [_vm._v("fibres")])]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("For the projects in this book, I have considered whether they need to be made of tough fibres to resist wear, such as cotton or wool, or are suitable to be worked in softer fibres, such as silk, because they are more decorative than practical. For example, a throw draped over a bed will get less wear and tear than one covering a sofa, while a floor cushion or seating cube needs to be made of more robust yarn than cushions scattered on an armchair.")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("The guide to natural and synthetic fibres below will help you think about the textures, finish and weight of the various yarns available. Think carefully about what type of yarn would be most suitable for your home furnishing project. Some fibres, such as angora or mohair, shed hairs, so these are not practical yarns to make an everyday throw covering a sofa – just think of all those hairs getting on your clothes! However, these are great fibres to use to make soft, fluffy bedroom throws and cushions. Some yarns combine more fragile fibres with more robust ones; silk mixed with wool, for example, produces a fabric with the sheen of the silk but with the hard-wearing qualities of the wool. Some fibres cost more than others; throws take up a large quantity of yarn, so you could keep expensive fibres for smaller cushions or combine them in stripes or blocks with less costly yarns.")]), _c('a', {
    attrs: {
      "id": "p9000f1639970009002"
    }
  }), _c('div', {
    staticClass: "aahead"
  }, [_c('h4', {
    staticClass: "aahead-title"
  }, [_c('strong', [_vm._v("NATURAL FIBRES")])]), _c('p', {
    staticClass: "firstpara"
  }, [_c('strong', [_vm._v("Alpaca")]), _vm._v(" is spun from the coat of the alpaca, a close relation of the llama. It is a wonderfully soft and lustrous yarn, which has many of the qualities of cashmere but at a more affordable price. Angora yarn can shed hairs, so it may be unsuitable for high-use items.")]), _c('p', {
    staticClass: "para"
  }, [_c('strong', [_vm._v("Angora")]), _vm._v(" hair comes from the angora rabbit. A yarn with a high content of angora is very fluffy and sheds hairs. It is usually blended with another fibre to give it stability, making a super-soft yarn ideal for feminine cushions.")]), _c('p', {
    staticClass: "para"
  }, [_c('strong', [_vm._v("Cashmere")]), _vm._v(" is spun from the hair of the cashmere goat. Pure cashmere yarn is very expensive and best kept for luxurious cushions. When it is blended with another fibre such as wool it becomes much more affordable.")]), _c('p', {
    staticClass: "para"
  }, [_c('strong', [_vm._v("Cotton")]), _vm._v(" comes from the ball of the cotton plant. It is a heavy fibre, very hard-wearing, and available in a great range of colours. Cotton can be mercerized; this is a process to give it lustre and take brighter dyes. Matte cotton tends to be more loosely spun. Use it for bright summer throws or floor cushions.")]), _c('p', {
    staticClass: "para"
  }, [_c('strong', [_vm._v("Linen")]), _vm._v(" comes from the stem of the flax plant, and it is often blended with cotton to soften it. In its natural colour, it will add rustic simplicity to a country cottage; dyed and it has an understated elegance, ideal for city chic.")]), _c('p', {
    staticClass: "para"
  }, [_c('strong', [_vm._v("Mohair")]), _vm._v(" is spun from the coat of the angora goat. The softer kid mohair is the first or second shearing of a kid goat and is finer than the mohair from the adult goat. Mohair is usually blended with another fibre to give it strength. It is light and so is ideal for soft, cosy bedroom throws.")]), _c('p', {
    staticClass: "para"
  }, [_c('strong', [_vm._v("Silk")]), _vm._v(" is a continuous filament secreted by the silkworm larva, which it spins around itself to form a cocoon. This cocoon is unwound and many of these fibres are spun together to form a yarn. Silk has a lustre, is soft, and has a dry feel. Use it blended with cotton or wool to make it more hard-wearing. It adds luxury to any room.")]), _c('p', {
    staticClass: "para"
  }, [_c('strong', [_vm._v("Wool")]), _vm._v(" is spun from the fleece of a sheep; different breeds of sheep give different qualities of yarn. Merino wool is very soft, Shetland is more hard-wearing, Wensleydale is very lustrous and Jacob wool is spun in fantastic natural colours. Wool has excellent insulating qualities; it is warm in winter and cool in summer. Many of the projects in this book use wool and it is a great yarn for a beginner to use. It knits up beautifully and can be pulled back and recycled without loss of quality. Tweed wool adds instant warmth to a room, and natural shades of wool will soften hard urban edges.")])]), _c('a', {
    attrs: {
      "id": "p9000f1639970009003"
    }
  }), _c('div', {
    staticClass: "aahead"
  }, [_c('h4', {
    staticClass: "aahead-title"
  }, [_c('strong', [_vm._v("BLENDED AND SYNTHETIC FIBRES")])]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("Blended yarns of natural and synthetic fibres combine the natural yarn’s qualities with the hard-wearing and stable features of the synthetic. Some of the synthetic fibres used in the projects are acrylic, metallic, nylon, polyamide fibre, polyester and viscose. Synthetic fibres are spun into the most wonderful fancy yarns, such as eyelash and ribbon. They take dyes well and will add a vibrant glow of colour to a minimalist interior or clash wonderfully in a retro-inspired room.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "p9000f1639960009002"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f163g9001.png",
      "width": "35.93467%"
    }
  })]), _c('a', {
    attrs: {
      "id": "p9000f1639960009001"
    }
  }), _c('div', {
    staticClass: "extract-group"
  }, [_c('p', {
    staticClass: "para-header-left"
  }, [_c('strong', [_vm._v("FIBRE CHECKLIST")])]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("When you are choosing yarn for a knitted project for an interior, use the checklist below to see what qualities your yarn offers.")]), _c('p', {
    staticClass: "para"
  }, [_c('strong', [_vm._v("Hard-wearing:")]), _vm._v(" Blended and synthetic fibres, cotton, linen, wool")]), _c('p', {
    staticClass: "para"
  }, [_c('strong', [_vm._v("Luxury:")]), _vm._v(" Cashmere, silk")]), _c('p', {
    staticClass: "para"
  }, [_c('strong', [_vm._v("Soft and snuggly:")]), _vm._v(" Alpaca, angora, mohair")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  })])]), _c('a', {
    attrs: {
      "id": "p9000f1639970010001"
    }
  }), _c('div', {
    staticClass: "ahead"
  }, [_c('h3', {
    staticClass: "ahead-title"
  }, [_c('strong', [_vm._v("Weight")])]), _c('a', {
    attrs: {
      "id": "p9000f1639960010002"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f163g10001.png",
      "width": "90.38113%"
    }
  })]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("The weight of a yarn refers to its thickness; a light-weight yarn is thin, and knits up into a soft, delicate fabric. A medium-weight yarn is thicker and knits up into a chunkier fabric. Experiment with new yarns and discover how a fabric can be changed by altering the weight of yarn used. Thick yarns such as bulky and super-bulky are ideal for knitting up into larger projects such as the Rustic Entrelac throw (pages 66–73). They grow quickly and produce a warm, thick fabric. Light- and medium-weight yarns can be used for finer details on cushions, or for mixing together as in the On the Fringes throw (pages 20–23). Use several strands together of very thin yarns like super-fine weight to make a thicker yarn or add them into a yarn mix.")]), _c('a', {
    attrs: {
      "id": "p9000f1639960010003"
    }
  }), _c('div', {
    staticClass: "extract-group"
  }, [_c('p', {
    staticClass: "para-header-left"
  }, [_c('strong', [_vm._v("STANDARD YARN WEIGHTS")])]), _c('a', {
    attrs: {
      "id": "p9000f1639960010001"
    }
  }), _c('div', {
    staticClass: "table-group"
  }, [_c('a', {
    attrs: {
      "id": "p9000f1639820010001"
    }
  }), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "3",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabletitle"
  }, [_c('strong', [_vm._v("weight")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabletitle"
  }, [_c('strong', [_vm._v("gauge*")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabletitle"
  }, [_c('strong', [_vm._v("needle size**")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabletitle"
  }, [_c('strong', [_vm._v("yarn type***")])])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" super-fine ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 27–32 sts ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 1 to 3 (2.25–3.25mm) ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" sock, fingering (2ply, 3ply) ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" fine ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 23–26 sts ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 3 to 5 (3.25–3.75mm) ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" sport, baby (4ply) ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" light ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 21–24 sts ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 5 to 7 (3.75–4.5mm) ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" light worsted, DK (DK) ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" medium  ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 16–20 sts ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 7 to 9 (4.5–5.5mm) ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" worsted, afghan (aran) ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" bulky ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 12–15 sts ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 9 to 11 (5.5–8mm) ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" chunky ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" super-bulky ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 6–11 sts ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 11 (8mm) and above ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" super-chunky ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "4",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablenote"
  }, [_vm._v(" Notes: * Gauge (tension) is measured over 4in/10cm in stockinette (stocking) stitch ")]), _c('p', {
    staticClass: "tablenote"
  }, [_vm._v(" ** US needle sizes are given first, with UK equivalents in brackets ")]), _c('p', {
    staticClass: "tablenote"
  }, [_vm._v(" *** Alternative US yarn type names are given first, with UK equivalents in brackets ")])])])])])])]), _c('a', {
    attrs: {
      "id": "p9000f1639970010002"
    }
  }), _c('div', {
    staticClass: "aahead"
  }, [_c('h4', {
    staticClass: "aahead-title"
  }, [_c('strong', [_vm._v("YARN WEIGHTS")])]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("A light-weight (DK) yarn knits up into a thinner fabric than a medium-weight (aran) yarn. Many of the projects in this book use medium (aran), bulky (chunky) or super-bulky (super-chunky) weight yarns; often several strands of fine (4ply) or light-weight (DK) yarns are used together to make a thicker yarn.")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("Yarns are sometimes described by a number of ply, for example, 2ply, 4ply or 6ply. A ply is a single twisted strand. As a general rule, the more plies that are twisted together, the thicker the yarn. However, just to confuse things, plies can be different thicknesses themselves. A tightly spun ply will be thinner than a loosely spun one. For example, a 2ply Shetland wool yarn knits up to fine-weight (4ply) gauge, and a thick Lopi yarn (a type of wool traditionally sourced from Iceland) is a single ply.")])]), _c('a', {
    attrs: {
      "id": "p9000f1639970010003"
    }
  }), _c('div', {
    staticClass: "aahead"
  }, [_c('h4', {
    staticClass: "aahead-title"
  }, [_c('strong', [_vm._v("CRAFT YARN COUNCIL OF AMERICA’S STANDARD YARN WEIGHTS")])]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("To avoid confusion when referring to weights of yarn in this book, I have adopted a standard developed by the Craft Yarn Council of America (see table, left), which divides yarns into weight rather than number of plies. Throughout this book I have given a generic description of each yarn used, specifying the weight and type of yarn that I have used for each project. This means that you can use any yarn that is the same weight to knit your project; this is especially useful if the one featured has been discontinued, as happens occasionally. (If you want to use exactly the same yarns for the projects that are featured in this book, see pages 124–126 for details.)")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("Yarn manufacturers in the US and in the UK sometimes use different names to identify the same weight of yarn. Where they differ, I have included both in the table left. Throughout this book, I give the US weight first, with the UK equivalent following in brackets.")]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "p9000f1639960011001"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f163g11001.png",
      "width": "90.38113%"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "p9000f1639970011001"
    }
  }), _c('div', {
    staticClass: "ahead"
  }, [_c('h3', {
    staticClass: "ahead-title"
  }, [_c('strong', [_vm._v("colour")])]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("Colour is a personal choice; no doubt you have your own favourite palette of colours that you use to create your interior spaces. You may also be inspired by the age or location of your home – modern or period, urban or rural. Below is an introduction to some of the palettes that I have used for the projects in this book, together with some alternative ideas.")]), _c('a', {
    attrs: {
      "id": "p9000f1639970011002"
    }
  }), _c('div', {
    staticClass: "aahead"
  }, [_c('h4', {
    staticClass: "aahead-title"
  }, [_c('strong', [_vm._v("A GUIDE TO COLOUR")])]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("The palettes described here refer to the colour swatch cards shown above.")]), _c('p', {
    staticClass: "para"
  }, [_c('strong', [_vm._v("Natural palette (1)")]), _vm._v(" This palette is calm, restful and sophisticated. It is suitable for a home full of natural materials such as wood, stone and terracotta. These are the colours of nature, including earth pigments like ochre and sand, browns inspired by woodlands, and chocolate and coffee. Shades of grey are inspired by pebbles and stones, while undyed ecru and unbleached linen add an organic tone. The Mixed Messages table runner (pages 44–47) uses a palette of shades of ecru in natural fibres.")]), _c('p', {
    staticClass: "para"
  }, [_c('strong', [_vm._v("Warm palette (2)")]), _vm._v(" Warm colours are mixed with red or yellow, so think of orange, orange-yellow, red and hot pink. These shades are fiery, strong and bright, and bring warmth into the home during autumn and winter or add strong colour into a minimalist room. Use shades of red together or mix up shades of spicy orange and yellow-orange. The On the Fringes throw (pages 20–23) uses a warm palette of orange and pink, while the Citrus Squares seating cube (pages 56–59) combines citrus shades of lemon, orange and lime with hot pink.")]), _c('p', {
    staticClass: "para"
  }, [_c('strong', [_vm._v("Cool palette (3)")]), _vm._v(" Cool colours are based on blue and yellow, so include green, blue and blue-violet as well as mixes of these shades, such as yellow-green, blue-green, turquoise and purple. These colours are ideal for spring and summer or for light airy rooms such as those decorated in greyed Scandinavian colours. Use shades of one colour; choose sea-inspired blues including aqua, grey-blue and pale turquoise, or shades of green from mint to sage. The Rippling Waves throw (pages 96–99) is worked in cool shades of grey, aqua and blue with flashes of sea greens. The Taking the Floor cushion (page 78) has a cool palette of greens combined with shades of mauve.")]), _c('p', {
    staticClass: "para"
  }, [_c('strong', [_vm._v("Rich palette (4)")]), _vm._v(" To add luxury and opulence to a room, think of jewel colours such as ruby, amethyst and emerald. These add drama and mystery and could be used just for the evening or for the Christmas party season. The Sizzling Stripes cushions (pages 40–43) combine shades of red or purple with metallics to create a luxurious look. The Sequinned Shimmer throw (pages 30–33) is a deep purple set off with opulent gold trimmings.")]), _c('p', {
    staticClass: "para"
  }, [_c('strong', [_vm._v("Light palette (5)")]), _vm._v(" Light palettes are ideal for spring days, soft feminine bedrooms or country cottages. They include icy pastels like aqua, mint green, peach and pale pink, and soft pastels such as lilac, sugared pink and mauve. The Rose Garden bedspread (pages 86–89) uses a dark rose together with pale pastel rose shades.")]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "p9000f1639960012001"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f163g12001.png",
      "width": "90.38113%"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "p9000f1639970012001"
    }
  }), _c('div', {
    staticClass: "ahead"
  }, [_c('h3', {
    staticClass: "ahead-title"
  }, [_c('strong', [_vm._v("texture")])]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("Yarns are made in a wide range of textures, from plain, plied yarns to extravagant concoctions of ribbon, bouclé or eyelash. Combining different textures together produces fantastic knitted fabrics, such as the On the Fringes throw (pages 20–23) or the Colour Carnival cushion (pages 48–49). Try mixing an eyelash yarn with tweed, or chenille with a metallic thread to make thicker yarns. Keep the textured yarns for plain stitches such as stockinette stitch or garter stitch; stitch patterns and cables are often lost in such yarns. Choose crisp cottons or smooth wools to show off the more complex stitches instead. Use the guide to texture set out here for more information.")]), _c('a', {
    attrs: {
      "id": "p9000f1639970012002"
    }
  }), _c('div', {
    staticClass: "aahead"
  }, [_c('h4', {
    staticClass: "aahead-title"
  }, [_c('strong', [_vm._v("Funky loops (1)")])]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("Astrakhan yarn has a texture of loose loops that curl across the surface of the fabric. Use a simple stockinette stitch to display its texture fully.")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bouclé has a similar looped texture to astrakhan, formed when a loosely spun strand is allowed to wrap around itself into snarls and snags. Cotton bouclé is crisp and produces a dense texture rather like a towel. Softer bouclés in mohair and wool make a luxurious, deep fabric.")])]), _c('a', {
    attrs: {
      "id": "p9000f1639970012003"
    }
  }), _c('div', {
    staticClass: "aahead"
  }, [_c('h4', {
    staticClass: "aahead-title"
  }, [_c('strong', [_vm._v("Rich velvet (2)")])]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("Chenille is a short-pile yarn that produces a wonderfully thick, velvety fabric. It is available in different weights from fine (4ply) to bulky (chunky). The thicker version would be great on its own; a thinner chenille would add a touch of softness and luxury to a yarn mix.")])]), _c('a', {
    attrs: {
      "id": "p9000f1639970012004"
    }
  }), _c('div', {
    staticClass: "aahead"
  }, [_c('h4', {
    staticClass: "aahead-title"
  }, [_c('strong', [_vm._v("Modern edge (3)")])]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("Metallic yarns are crunchy, futuristic and full of light. They are often a mix of viscose and metallic elements and add a sharp highlight in a soft, fluid fabric. Add these yarns to any yarn mix to create instant glamour.")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Mercerized cotton is a tight, lustrous yarn that makes a very clean, crisp fabric. Mercerized cotton contributes one of the vivid reds of the Brilliant Bolster (pages 40–42).")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("Cord is a smooth, round yarn. When cord is knitted, each stitch sits apart from its neighbours, producing an open fabric. This would add structure to a softer yarn mix.")])])]), _c('a', {
    attrs: {
      "id": "p9000f1639970013001"
    }
  }), _c('div', {
    staticClass: "aahead"
  }, [_c('h4', {
    staticClass: "aahead-title"
  }, [_c('strong', [_vm._v("Fluid (4)")])]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("Ribbons can be multi-coloured, stranded with metallic, open or solid structures, fluffy or crisp, slinky or hard. They are flat and vary in width from narrow to wide, and are available in any fibre, from wool to modern synthetics. The Bead Me Up cushion (pages 34–35) uses a bright glossy ribbon yarn for a contemporary feel, while the On the Fringes throw (pages 20–23) features a spicy metallic ribbon in the mix.")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("Tape is a fluid knitted flat yarn that rarely produces a completely flat fabric; it twists and folds on your needles. It folds in half for one stitch and then opens out for the next. Viscose tapes produce wonderfully slinky fabric.")])]), _c('a', {
    attrs: {
      "id": "p9000f1639970013002"
    }
  }), _c('div', {
    staticClass: "aahead"
  }, [_c('h4', {
    staticClass: "aahead-title"
  }, [_c('strong', [_vm._v("Fluffy and furry (5)")])]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("Mohair is a soft, fluffy yarn; the fibres trap air and light to produce a feather-soft fabric. Use in a mix with heavier yarns to add a haze of colour.")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("Eyelash yarn looks like a frayed ribbon. Available in width from narrow to outrageously wide, it knits up into a fabric of deep shimmering waves. Try showing it off by working it in stripes with contrasting smooth yarns.")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("Fake or faux fur produces a deep pile great for winter throws or as a trim around a cushion.")])]), _c('a', {
    attrs: {
      "id": "p9000f1639970013003"
    }
  }), _c('div', {
    staticClass: "aahead"
  }, [_c('h4', {
    staticClass: "aahead-title"
  }, [_c('strong', [_vm._v("Warm and woolly (6)")])]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("Tweed wool yarn is a combination of two or more colours, spun together or introduced as slubs or knots of colour. A knitted tweed fabric looks warm, cosy and resilient. You can contrast it with metallic or cotton for an exciting twist. Pure wool tweed makes fantastic fulled fabric; the colours merge into a dense brushed fabric, as seen on the Celtic Knot Garden cushion (pages 36–39).")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("Smooth wool yarn shows stitch textures beautifully and is available in a great range of colours. It is hard-wearing and very easy to knit with. Undyed wool in natural colours can add warmth and a homespun feel to urban interiors.")])]), _c('a', {
    attrs: {
      "id": "p9000f1639970013004"
    }
  }), _c('div', {
    staticClass: "aahead"
  }, [_c('h4', {
    staticClass: "aahead-title"
  }, [_c('strong', [_vm._v("Dry summer (7)")])]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("Matte cotton has a fantastic dry texture; it has weight and will add strength and structure to a yarn mix. The colours can be fantastically dusty, like painted plaster, or zingy like citrus fruit, such as those used in the Citrus Squares seating cube (pages 56–59).")])]), _c('a', {
    attrs: {
      "id": "p9000f1639970013005"
    }
  }), _c('div', {
    staticClass: "aahead"
  }, [_c('h4', {
    staticClass: "aahead-title"
  }, [_c('strong', [_vm._v("Mixed media (8)")])]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("The Mixing It Up runner and cushion (pages 44–49) show how using fibres other than knitting yarn can add unexpected texture. Use ribbons, braids, furnishing trims, strung sequins and beads, or cut fabric and net into strips.")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  })])]), _c('a', {
    attrs: {
      "id": "p9000f1639970014001"
    }
  }), _c('div', {
    staticClass: "ahead"
  }, [_c('h3', {
    staticClass: "ahead-title"
  }, [_c('strong', [_vm._v("needles")])]), _c('a', {
    attrs: {
      "id": "p9000f1639960014001"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f163g14001.png",
      "width": "90.38113%"
    }
  })]), _c('a', {
    attrs: {
      "id": "p9000f1639820014001"
    }
  }), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "3",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabletitle"
  }, [_vm._v(" NEEDLE SIZES ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabletitle"
  }, [_vm._v(" US ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabletitle"
  }, [_vm._v(" Metric ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 0 ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 2mm ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 1 ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 2.25mm ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  })]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 2.5mm ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 2 ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 2.75mm ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  })]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 3mm ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 3 ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 3.25mm ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 4 ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 3.5mm ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 5 ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 3.75mm ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 6 ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 4mm ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 7 ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 4.5mm ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 8 ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 5mm ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 9 ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 5.5mm ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 10 ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 6mm ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 10½ ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 6.5mm ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  })]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 7mm ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 11 ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 8mm ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 13 ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 9mm ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 15 ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 10mm ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 17 ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 12.75mm ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 19 ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 15mm ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 35 ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 19mm ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  })]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" 20mm ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  })]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-para"
  })])])])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  })]), _c('a', {
    attrs: {
      "id": "p9000f1639970015001"
    }
  }), _c('div', {
    staticClass: "ahead"
  }, [_c('h3', {
    staticClass: "ahead-title"
  }, [_c('strong', [_vm._v("gauge")])]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("At the beginning of every project, I have given the gauge (tension) that you need to achieve to make the project successfully. The gauge is the number of stitches and rows you need to make a 1in (2.5cm) square. This is a very important part of knitting; if you do not obtain the correct gauge, the throw or cushion may come out bigger or smaller than you would like. It is especially important when you are knitting a cushion to fit a specific size of cushion pad.")]), _c('a', {
    attrs: {
      "id": "p9000f1639970015002"
    }
  }), _c('div', {
    staticClass: "aahead"
  }, [_c('h4', {
    staticClass: "aahead-title"
  }, [_c('strong', [_vm._v("GAUGE MEASUREMENTS")])]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("The gauge is given over 4in (10cm). For example: the gauge for a light-weight (DK) yarn is 22 stitches and 28 rows to 4in (10cm) measured over stockinette stitch on size 6 (4mm) needles. To check your gauge, you must work a square of fabric measuring at least 6in (15cm), using the stated yarn, needle size and stitch. You can then measure the fabric in the middle of the square, avoiding the edge stitches, which will be distorted.")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sometimes you will find that it is difficult to achieve both the correct stitch and row count for your gauge square. It is usually more important to obtain the correct stitch count, so you should concentrate on achieving that. The row count matters only in projects that are written row by row rather than measured to length, such as the Celtic Knot Garden cushion (pages 36–39).")])]), _c('a', {
    attrs: {
      "id": "p9000f1639970015003"
    }
  }), _c('div', {
    staticClass: "aahead"
  }, [_c('h4', {
    staticClass: "aahead-title"
  }, [_c('strong', [_vm._v("KNITTING A GAUGE SQUARE")])]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("To knit a gauge square in stockinette stitch, you need to cast on the number of stitches stated for 4in (10cm) plus half as many again. For example: 22 sts plus 11 sts.")]), _c('a', {
    attrs: {
      "id": "p9000f1639960015001"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f163g15001.png",
      "width": "29.76406%"
    }
  })]), _c('p', {
    staticClass: "firstpara"
  }, [_c('strong', [_vm._v("1")]), _vm._v(" Work in stockinette stitch for 6in (15cm) and then bind off loosely.")]), _c('p', {
    staticClass: "para"
  }, [_c('strong', [_vm._v("2")]), _vm._v(" Steam or wet press the square in the way that you will use for your finished project (see page 116). The information on the ball band will tell you whether you can steam the yarn or not.")]), _c('p', {
    staticClass: "para"
  }, [_c('strong', [_vm._v("3")]), _vm._v(" Lay the square on a flat surface without stretching it. Place a ruler horizontally on the square and place a pin 1in (2.5cm) in from the edge and place another at 4in (10cm) from the first pin.")]), _c('p', {
    staticClass: "para"
  }, [_c('strong', [_vm._v("4")]), _vm._v(" Do the same for the rows by placing the ruler vertically, keeping away from the cast-on and bound-off edges, which may pull the fabric in.")]), _c('p', {
    staticClass: "para"
  }, [_c('strong', [_vm._v("5")]), _vm._v(" Count the number of stitches and rows between the pins: this is your gauge. If you have more stitches than the suggested number, your stitches are too small; you will need to use a size larger needle to make the stitches bigger and so obtain fewer stitches to 4in (10cm). If you have too few stitches, this means your stitches are too big; you need to use a size smaller needle to make the stitches smaller and so obtain more to 4in (10cm).")]), _c('p', {
    staticClass: "para"
  }, [_c('strong', [_vm._v("6")]), _vm._v(" Work another square until you achieve the gauge stated in the pattern.")])]), _c('a', {
    attrs: {
      "id": "p9000f1639970015004"
    }
  }), _c('div', {
    staticClass: "aahead"
  }, [_c('h4', {
    staticClass: "aahead-title"
  }, [_c('strong', [_vm._v("MEASURING TEXTURED YARNS")])]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("If you are using a textured yarn, it can be difficult to see individual stitches and rows. For yarns with a long pile, such as the faux fur shown, measure the 4in (10cm) for stitches and rows, placing a marker in a contrasting yarn. Leave long ends on these markers so they are visible through the long pile. Hold the square up to a window or a light (protect your eyes against a strong light). This will show up the stitches and rows clearly for you to count.")]), _c('a', {
    attrs: {
      "id": "p9000f1639960015002"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f163g15002.png",
      "width": "31.94192%"
    }
  })]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("With yarns that are heavily textured, such as the bouclé shown, or a thick fleece or plush yarn, the stitches close up and make a uniform surface when knitted. Knit a contrasting coloured sewing cotton in with the yarn. This will show up the stitches and rows and make counting easier. Mark the 4in (10cm) for stitches and rows with a contrasting thread, so you can pull the fabric to make out difficult stitches without losing any pins.")]), _c('a', {
    attrs: {
      "id": "p9000f1639960015003"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f163g15003.png",
      "width": "31.57895%"
    }
  })]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("It is often easier to make out the stitches and rows on the wrong side of the square (that is, on the reverse stockinette side), so try using this side to measure over.")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("If you are not sure what the individual stitches and rows look like, refer to page 105.")])]), _c('a', {
    attrs: {
      "id": "p9000f1639970015005"
    }
  }), _c('div', {
    staticClass: "aahead"
  }, [_c('h4', {
    staticClass: "aahead-title"
  }, [_c('strong', [_vm._v("MEASURING OVER A STITCH PATTERN")])]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("If the gauge is quoted over a stitch pattern like that used for the Denim Delight throw (see pages 80–85), cast on enough stitches to work complete repeats. The repeat of the pattern follows the asterisk; cast on a multiple of this number of stitches plus any stitches given at the beginning and end of the row.")])]), _c('a', {
    attrs: {
      "id": "p9000f1639970015006"
    }
  }), _c('div', {
    staticClass: "aahead"
  }, [_c('h4', {
    staticClass: "aahead-title"
  }, [_c('strong', [_vm._v("USING GAUGE FOR SUBSTITUTING YARNS")])]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("For all these projects, I have suggested other yarns to use or different weights of yarn to mix up into a unique yarn. It is very important to keep aiming for the stated gauge when you alter the yarn mix, or the project will not be the correct size and the finished fabric may be too loose or too tight.")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  })])]), _c('a', {
    attrs: {
      "id": "p9000f1639970016001"
    }
  }), _c('div', {
    staticClass: "ahead"
  }, [_c('h3', {
    staticClass: "ahead-title"
  }, [_c('strong', [_vm._v("abbreviations")])]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("Abbreviations are used in knitting patterns to shorten commonly used terms so that the instructions are easier to read and a manageable length. The following is a list of all the abbreviations you need to make the projects in this book.")]), _c('a', {
    attrs: {
      "id": "p9000f1639960016004"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f163g16001.png",
      "width": "41.01633%"
    }
  })]), _c('a', {
    attrs: {
      "id": "p9000f1639960016001"
    }
  }), _c('div', {
    staticClass: "table-group"
  }, [_c('a', {
    attrs: {
      "id": "p9000f1639820016001"
    }
  }), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "3",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("alt")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" alternate ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("approx")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" approximately ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("beg")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" begin/beginning ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("cm")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" centimetre(s) ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("cont")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" continue ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("dec(s)")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" decrease(s)/decreasing ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("DK")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" double knitting ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("foll")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" following ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("g")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" gram ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("g st")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" garter stitch (k every row) ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("in(s)")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" inch(es) ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("inc(s)")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" increase(s)/increasing ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("k")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" knit ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("k2tog")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" knit 2 stitches together (decrease 1 stitch) ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("k3tog")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" knit 3 stitches together (decrease 2 stitches) ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("LH")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" left hand ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("m")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" metre(s) ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("mm")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" millimetre(s) ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("M1")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" make one (increase 1 stitch) ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("MB")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" make a bobble ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("oz")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" ounces ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("p")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" purl ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("patt(s)")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" pattern(s) ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("patt rep(s)")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" pattern repeat(s) ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("p2tog")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" purl 2 stitches together (decrease 1 stitch) ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("p3tog")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" purl 3 stitches together (decrease 2 stitches) ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("psso")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" pass slipped stitch over ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("rem")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" remain/ing ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("rep(s)")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" repeat(s) ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("rev st st")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" reverse stockinette stitch (1 row p, 1 row k) ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("RH")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" right hand ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("RS")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" right side ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("sk2po")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" slip 1 stitch, knit 2 stitches together, pass slipped stitch over (decrease 2 stitches) ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("sl")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" slip ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("ssk")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" slip 2 stitches one at a time, knit 2 slipped stitches together (decrease 1 stitch) ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("ssp")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" slip 2 stitches one at a time, purl 2 slipped stitches together through the back of the loops (decrease 1 stitch) ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("st(s)")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" stitch(es) ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("st st")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" stockinette stitch (1 row k, 1 row p) (UK: stocking stitch) ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("tog")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" together ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("WS")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" wrong side ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("wyib")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" with yarn in back ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("wyif")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" with yarn in front ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("yd(s)")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" yard(s) ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("yfwd")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" yarn forward ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("yo")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" yarn over ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("*")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" repeat directions following * as many times as indicated or until end of row ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_c('strong', [_vm._v("( )")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v("repeat instructions in round brackets the number of times")])])])])])]), _c('a', {
    attrs: {
      "id": "p9000f1639960016003"
    }
  }), _c('div', {
    staticClass: "extract-group"
  }, [_c('p', {
    staticClass: "firstpara"
  }, [_c('em', [_vm._v("In the instructions for the projects, I have favoured US knitting terms. Refer to this box for the UK equivalent.")])]), _c('a', {
    attrs: {
      "id": "p9000f1639960016002"
    }
  }), _c('div', {
    staticClass: "table-group"
  }, [_c('a', {
    attrs: {
      "id": "p9000f1639820016002"
    }
  }), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "3",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabletitle"
  }, [_c('strong', [_vm._v("US TERM")])])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabletitle"
  }, [_c('strong', [_vm._v("UK TERM")])])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" bind off ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" cast off ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" gauge ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" tension ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" stockinette stitch ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" stocking stitch ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" reverse stockinette stitch ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" reverse stocking stitch ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" seed stitch ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" moss stitch ")])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" moss stitch ")])]), _c('td', {
    attrs: {
      "align": "left",
      "colspan": "NaN",
      "rowspan": "1",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablepara"
  }, [_vm._v(" double moss stitch ")])])])])])])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  })]), _c('a', {
    attrs: {
      "id": "p9000f1639970017001"
    }
  }), _c('div', {
    staticClass: "ahead"
  }, [_c('h3', {
    staticClass: "ahead-title"
  }, [_c('strong', [_vm._v("reading knitting patterns")])]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("A knitting pattern tells you how to knit and make up a knitted project. The instructions use shorthand phrases and abbreviations, otherwise they would be far too long. The abbreviations used in this book appear in a list on page 16 with an explanation of what they mean. Many are commonly used, such as k and p. Others refer to special stitches, like C4F. These are explained in the pattern and in the technique section at the back (see page 111 for cables).")]), _c('a', {
    attrs: {
      "id": "p9000f1639970017002"
    }
  }), _c('div', {
    staticClass: "aahead"
  }, [_c('h4', {
    staticClass: "aahead-title"
  }, [_c('strong', [_vm._v("WORKING FROM CHARTS")])]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("The Wobbly Stripe Seat (pages 92–95) is worked from a colour chart. There are usually very few written instructions for such charts, apart from how many stitches you need to cast on and any knitting that is not included on the chart. Working from charts is explained along with the technique for intarsia on pages 112–113. Sometimes the chart shows any shaping that has to be done, and this will be included in the instructions to set the chart. For example:")]), _c('p', {
    staticClass: "para"
  }, [_vm._v("Working RS rows (odd) from right to left and WS rows (even) from left to right, and dec 1 st at each end of 13th and every foll 8th row, work in st st from chart until the 64th row has been completed. 52 sts.")])]), _c('a', {
    attrs: {
      "id": "p9000f1639970017003"
    }
  }), _c('div', {
    staticClass: "aahead"
  }, [_c('h4', {
    staticClass: "aahead-title"
  }, [_c('strong', [_vm._v("IMPERIAL AND METRIC MEASUREMENTS")])]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("The patterns are written in both imperial (inches and ounces) and metric (centimetres and grams) measurements, and you should stick to one or the other; some imperial to metric measurements are not exact conversions.")])]), _c('a', {
    attrs: {
      "id": "p9000f1639970017004"
    }
  }), _c('div', {
    staticClass: "aahead"
  }, [_c('h4', {
    staticClass: "aahead-title"
  }, [_c('strong', [_vm._v("COMMON SHORTHAND PHRASES")])]), _c('p', {
    staticClass: "firstpara"
  }, [_vm._v("You will see some common shorthand phrases appearing in the pattern instructions. These include the following:")]), _c('p', {
    staticClass: "para"
  }, [_c('strong', [_vm._v("cont as set")]), _vm._v(" Instead of repeating the same instructions over and over, you must continue to work as previously told.")]), _c('p', {
    staticClass: "para"
  }, [_c('strong', [_vm._v("work as given for")]), _vm._v(" To avoid repeating instructions; can be used within one set of instructions or to show how to work another version of the throw or cushion.")]), _c('p', {
    staticClass: "para"
  }, [_c('strong', [_vm._v("*")]), _vm._v(" Repeat the directions following * as many times as indicated or until end of row.")]), _c('p', {
    staticClass: "para"
  }, [_c('strong', [_vm._v("**")]), _vm._v(" Usually appears at the beginning or beginning and end of a section of instructions and indicates that several rows of instructions should be repeated.")]), _c('p', {
    staticClass: "para"
  }, [_c('strong', [_vm._v("( )")]), _vm._v(" Repeat instructions in round brackets the number of times indicated.")]), _c('a', {
    attrs: {
      "id": "p9000f1639960017001"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f163g17001.png",
      "width": "75.86207%"
    }
  }), _c('div', {
    staticClass: "caption-group"
  }, [_c('p', {
    staticClass: "captionpara"
  }, [_c('em', [_c('strong', [_vm._v("The bold colours and sinuous wavy shapes of the Wobbly Stripe Seat (pages 92–95) are worked using the intarsia method from a chart. See left for more information on working from charts.")])])])])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "p9000f1639960018001"
    }
  }), _c('div', {
    staticClass: "media-group"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p9000f163g18001.png",
      "width": "90.38113%"
    }
  })])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-872f2b2c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch006.vue
// module id = 75
// module chunks = 0